export default __webpack_public_path__ + "assets/d8fe6fc5dcb90683c8ce457d56a43ff6.png";